//Author June Leow
//Date June 12th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, callBackGenerator, showMessage, formatDateTime} from '../../util/util';
import {Card, CardHeader, CardBody, Row, Col, Input, Button, Modal, ModalHeader, ModalBody} from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {NavLink, useParams} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {
  declineReasons:[],
  declineReason:'',
  declineComment:'',
  declinePopUp:false,

  appraisal:{
    reference_num:'',
    property_street:'',
    property_city:'',
    property_state:'',
    property_zip:'',
    loan_num:'',
    loan_purpose:'',
    loan_type:'',
    datetime_submitted:'0000-00-00',
    status:'',
    borrower_f_name:'',
    borrower_l_name:'',
    deadline_time:''
  },
  valid: false,
};

//reducer function that perform state update
const reducer = getReducer();


const AutoAssignAcceptance  = (props)=>{
  const controller = new AbortController();

  let id = useParams().id;
  let appraiserFk = useParams().appraiserFk;
  let newInitialState = Object.assign({}, initialState, {
    id:id,
    appraiserFk:appraiserFk
  });

  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);
  const apiCallBack = callBackGenerator(setState);
  const httpGetNoToken = getAPICallGenerator(props, {signal:controller.signal, noToken:true});
  const httpPostNoToken = postAPICallGenerator(props, {signal:controller.signal, noToken:true});

  //run only once when component is loaded
  useEffect(()=>{
    getAppraisal();
    getDeclineReasons();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const declinePopUpToggle=()=>{
    setState({declinePopUp:!state.declinePopUp});
  }

  //API call
  const getAppraisal=()=>{
    let callBack = (response)=>{console.log(response);
      let code = response.data.code;
      if(code==='00'){
        setState({appraisal:response.data.data});
        console.log(response.data.data);
        if(response.data.data.status==='Auto Assigning'&&response.data.data.appraiser_fk===state.appraiserFk)
          setState({valid:true});
      }
    };
    httpGetNoToken('appraisal/public/'+state.id, '', 'Oops, something went wrong and could not load the appraisal information. Please try again later.', callBack);
  }

  const setAcceptance=(action)=>{
    let successMsg = 'Assignment accepted successfully.';
    if(action==='no')
      successMsg = 'Assignment declined successfully.';
    let errorMsg = 'Oops, something went wrong and could not accept the assignment. Please try again later.';
    if(action==='no')
      errorMsg = 'Oops, something went wrong and could not decline the assignment. Please try again later.';

    let parameters = [
      {
        field:'orderID',
        value:state.id
      },
      {
        field:'appraiserFk',
        value:state.appraiserFk
      },
      {
        field:'action',
        value:action
      }
    ];

    if(action==='no'){
      let tmp = {
        field:'reason',
        value:state.declineReason
      };

      parameters.push(tmp);

      tmp = {
        field:'comment',
        value:state.declineComment
      }

      parameters.push(tmp);
    }

    let callBack = (response)=>{
      let code = response.data.code;

      if(code==='00'){
        setState({valid:false});
        if(action==='no')
          declinePopUpToggle();
      } else if(code==='04') {
        showMessage('error', 'The 1 hour and 30 minutes window to decline has expired. The assignment has been automatically accepted.');
        setState({valid:false, declinePopUp:false});
      } else if(code==='05') {
        showMessage('error', 'Cannot decline assignment after scheduling an inspection. Please contact support if you need assistance.');
        setState({valid:false, declinePopUp:false});
      }
    };

    httpPostNoToken('autoAssign/assignment/noSession/acceptance', parameters, successMsg, errorMsg, callBack);
  }

  const getDeclineReasons=()=>{
    let url = 'autoAssign/declineAutoAssignReason/get';
    const callBack = apiCallBack([{state:'declineReasons', key:'data'}]);
    httpGetNoToken('autoAssign/declineAutoAssignReason/get', '', 'Oops, something went wrong and could not load the information of this appraisal. Please try again later.', callBack);
  }

  //render
  let required = false;

  if(state.declineReason==='Other')
    required = true;

  let action;

  if(state.valid)
    action = <center>
      <b>You've been assigned a new order through Auto Assign.</b><br/><br/>
      <p>Click on the button below to reject the assignment.</p>
      <br/>
      <Button style={{width:'200px'}} color="danger" onClick={declinePopUpToggle}><i className="fa fa-times"></i> Decline Assignment</Button>
      <br/><br/>
    </center>;
  else if(!state.valid&&state.appraisal.reference_num!==''){
    if(state.appraisal.appraiser_fk!==state.appraiserFk){
      action = <center>
        The assignment rejection link is expired, please reach out to us about the order status.
      </center>
    }
    else{
      action = <center>
        This order had been declined.
      </center>
    }
  }
  else {
    action = <center>
      The assignment rejection link is expired, please reach out to us about the order status.
    </center>
  }



  return (
    <div>
      <div className="topbar">
          <div className="topbar-logo-container">
            <NavLink to="/"><img className="topbar-logo-img" alt="@Home VMS Logo" width="120px" src="/img/logo_small.png"/></NavLink>
          </div>
      </div>
      <div className="padding">
        <Row>
          <Col sm="1">

          </Col>
          <Col sm="10">
            <Card style={{background:'#f5f5f5'}}>
              <CardHeader className="header-color">
                <center>
                    <i className="fa fa-edit"></i> Reject Assignment
                </center>
              </CardHeader>
              <CardBody>
                <div style={{background:'white', border:'1px solid #d2d2d2',padding:'5px',borderRadius:'5px'}}>
                  <label>Reference #:&nbsp;&nbsp;</label>
                  {state.appraisal.reference_num}

                  <br/>
                  <label>Status:&nbsp;&nbsp;</label>
                  {state.appraisal.status}

                  <br/>
                  <label>Property address:&nbsp;&nbsp;</label>
                  {state.appraisal.property_street+' '+state.appraisal.property_city+', '+state.appraisal.property_state+' '+state.appraisal.property_zip}

                  <br/>
                  <label>Borrower:&nbsp;&nbsp;</label>
                  {state.appraisal.borrower_f_name+' '+state.appraisal.borrower_l_name}

                  <br/>
                  <label>Loan purpose:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_purpose}

                  <br/>
                  <label>Loan type:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_type}

                  <br/>
                  <label>Loan #:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_num}

                  <br/>
                  <label>Date submitted:&nbsp;&nbsp;</label>
                  {formatDateTime(state.appraisal.datetime_submitted)}

                  <br/>
                </div>
                <div className="my-divider"></div>
                <Modal className="my-modal" isOpen={state.declinePopUp} toggle={declinePopUpToggle} >
                  <ModalHeader hidden={true} toggle={declinePopUpToggle}></ModalHeader>
                  <ModalBody>
                    <form onSubmit={(e)=>{e.preventDefault();setAcceptance('no')}}>
                      <label>Reason</label>
                      <Input required="true" type="select" onChange={(e)=>setState({declineReason:e.target.value})}>
                        <option key=""></option>
                        {
                          state.declineReasons.map(
                            (reason,index)=>{
                              return <option key={index} value={reason.reason}>{reason.reason}</option>
                            }
                          )
                        }
                      </Input>
                      <br/>
                      <label>Comment</label>
                      <Input required={required} onChange={(e)=>setState({declineComment:e.target.value})} type="textarea" rows="5" style={{resize:'none'}}></Input>
                      <br/>

                      <b><font color="red">*</font>By declining this assignment, the order will be immediately released and reassigned to another appraiser. You will no longer have access to this order.</b>
                      <div className="my-divider">&nbsp;</div>
                      <center>
                        <Button color="info" onClick={declinePopUpToggle}>Close</Button>&nbsp;
                        <Button color="danger">Decline</Button>
                      </center>
                    </form>
                  </ModalBody>
                </Modal>

                <div style={{background:'white', border:'1px solid #d2d2d2',padding:'5px',borderRadius:'5px'}}>
                  <br/>
                  {action}
                  <br/>
                </div>
                <br/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}


export default AutoAssignAcceptance;
